import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const generateSalePDF = async (sale, productName, tenantName) => {
  try {
    const container = document.createElement("div");

    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.width = "80mm";
    container.style.background = "#fff";
    container.style.padding = "10px";
    container.style.fontFamily = "monospace";
    container.style.color = "#000";

    // -------------------------
    // SAFE FALLBACKS
    // -------------------------
    const saleDate =
      sale.saleDate ||
      sale.SaleDate ||
      new Date().toLocaleString();

    const saleId =
      sale.saleId ||
      sale.SaleId ||
      "N/A";

    const paymentMethod =
      sale.paymentMethod ||
      sale.PaymentMethod ||
      "Cash";

    const items = sale.items || [];

    const parseNumber = (v) => {
      if (v === null || v === undefined) return 0;
      const n = Number(String(v).replace(/[^0-9.-]+/g, ""));
      return Number.isNaN(n) ? 0 : n;
    };

    const formatCurrency = (v) =>
      `₦${parseNumber(v).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;

    const totalQty = items.reduce(
      (sum, item) =>
        sum + (item.quantity || item.Quantity || 0),
      0
    );

    const subtotal =
      sale.subtotal ?? sale.Subtotal ?? sale.total ?? 0;

    const discount =
      sale.discount ?? sale.Discount ?? 0;

    const tax =
      sale.tax ?? sale.Tax ?? 0;

    const total =
      sale.total ?? sale.Total ?? 0;

    const cashier =
      sale.cashierName ||
      sale.CashierName ||
      "Admin";

    // -------------------------
    // ITEMS ROWS (CLEAN)
    // -------------------------
    const itemsHtml = items.length
      ? items
          .map((item) => {
            const qty =
              item.quantity || item.Quantity || 0;

            const unitPrice =
              item.unitPrice ||
              item.UnitPrice ||
              item.price ||
              item.Price ||
              0;

            const amount = qty * unitPrice;

            const name =
              item.productName ||
              item.ProductName ||
              "Item";

            return `
              <tr>
                <td colspan="4" style="padding-top:6px;">
                  <strong>${name}</strong>
                </td>
              </tr>

              <tr>
                <td>${qty}</td>
                <td>${formatCurrency(unitPrice)}</td>
                <td colspan="2" style="text-align:right;">
                  ${formatCurrency(amount)}
                </td>
              </tr>

              <tr>
                <td colspan="4">
                  <hr style="border:none;border-top:1px dashed #ccc;" />
                </td>
              </tr>
            `;
          })
          .join("")
      : `<tr><td>No items found</td></tr>`;

    // -------------------------
    // RECEIPT HTML
    // -------------------------
    container.innerHTML = `
      <div style="text-align:center; margin-bottom:10px;">
        <h2 style="margin:0; font-size:18px;">
          ${tenantName || "STOKRAZE"}
        </h2>
        <div style="font-size:11px;">SALES RECEIPT</div>
        <hr />
      </div>

      <div style="font-size:11px; margin-bottom:10px;">
        <div><strong>Receipt #:</strong> ${saleId}</div>
        <div><strong>Date:</strong> ${saleDate}</div>
        <div><strong>Cashier:</strong> ${cashier}</div>
        <div><strong>Payment:</strong> ${paymentMethod}</div>
      </div>

      <hr />

      <table style="width:100%; font-size:11px; border-collapse:collapse;">
        <thead>
          <tr>
            <th style="text-align:left;">Item</th>
            <th>Qty</th>
            <th>Price</th>
            <th style="text-align:right;">Total</th>
          </tr>
        </thead>

        <tbody>
          ${itemsHtml}
        </tbody>
      </table>

      <hr />

      <div style="font-size:11px;">
        <div style="display:flex; justify-content:space-between;">
          <span>Subtotal</span>
          <span>${formatCurrency(subtotal)}</span>
        </div>

        <div style="display:flex; justify-content:space-between;">
          <span>Discount</span>
          <span>${formatCurrency(discount)}</span>
        </div>

        <div style="display:flex; justify-content:space-between;">
          <span>Tax</span>
          <span>${formatCurrency(tax)}</span>
        </div>
      </div>

      <hr />

      <div style="display:flex; justify-content:space-between; font-size:14px;">
        <strong>TOTAL</strong>
        <strong>${formatCurrency(total)}</strong>
      </div>

      <hr />

      <div style="text-align:center; margin-top:12px; font-size:10px;">
        <div>Total Items: ${totalQty}</div>
        <br/>
        Payment Method: ${paymentMethod}
        <br/><br/>
        Thank you for shopping with us
        <br/>
        <strong>Powered by Stokraze</strong>
        <br/>
        ${new Date().toLocaleString()}
      </div>
    `;

    // -------------------------
    // GENERATE PDF
    // -------------------------
    document.body.appendChild(container);

    const canvas = await html2canvas(container, {
      scale: 2,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");

    const pdfWidth = 80; // mm thermal width
    const pdfHeight =
      (canvas.height * pdfWidth) / canvas.width;

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [pdfHeight, pdfWidth],
    });

    pdf.addImage(
      imgData,
      "PNG",
      0,
      0,
      pdfWidth,
      pdfHeight
    );

    pdf.save(`Sale_${saleId}.pdf`);

    document.body.removeChild(container);
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};